export default __webpack_public_path__ + "static/media/icon-activity-pageview.1527105c.svg";